import React from 'react';
import Button from '../../ui/buttons/Button';
import ObjectiveForm from './ObjectivesForm';

const newTempId = () =>
  typeof crypto !== 'undefined' && crypto.randomUUID
    ? crypto.randomUUID()
    : `tmp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

const ObjectivesFormList = ({ objectives, onChange, canWrite = true }) => {
  const visible = objectives.map((o, originalIndex) => ({ ...o, _idx: originalIndex })).filter((o) => !o._destroy);

  const handleChange = (originalIndex, updated) => {
    const updatedList = [...objectives];
    updatedList[originalIndex] = updated;
    onChange(updatedList);
  };

  const handleAdd = () => {
    onChange([...objectives, { tempId: newTempId(), title: '', desired_date: '', total_value: '', _destroy: false }]);
  };

  const handleRemove = (originalIndex) => {
    const updatedList = [...objectives];
    const item = updatedList[originalIndex];

    if (item?.id) {
      // marcar para destruir (imutável)
      updatedList[originalIndex] = { ...item, _destroy: true };
    } else {
      // novo: remover do array
      updatedList.splice(originalIndex, 1);
    }
    onChange(updatedList);
  };

  return (
    <>
      <div className="space-y-4 bg-tealWhisper rounded-xl border border-tealPale p-5">
        {visible.map(({ _idx, ...objective }) => (
          <div
            key={objective.id || objective.tempId} // chave estável
            className="bg-white border border-gray-200 rounded-2xl shadow-sm p-6"
          >
            <ObjectiveForm
              index={_idx} // índice do array original
              objective={objective}
              onChange={handleChange}
              onRemove={handleRemove}
              canWrite={canWrite}
            />
          </div>
        ))}
      </div>

      {canWrite && (
        <div className="pt-4">
          <Button onClick={handleAdd} type="button">
            + ADICIONAR OBJETIVO
          </Button>
        </div>
      )}
    </>
  );
};

export default ObjectivesFormList;
